"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_script_1 = require("../create-script");
var get_script_by_src_1 = require("../get-script-by-src");
var polyfillWindow = window;
var polyfillesLoadedFn = function () {
    if (polyfillWindow.polyfillsLoadedCallbacks.length) {
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < polyfillWindow.polyfillsLoadedCallbacks.length; i++) {
            polyfillWindow.polyfillsLoadedCallbacks[i]();
        }
    }
    polyfillWindow.polyfillsLoadedFlag = true;
};
polyfillWindow.polyfillsLoadedFlag = false;
polyfillWindow.polyfillsLoadedCallbacks =
    polyfillWindow.polyfillsLoadedCallbacks || [];
polyfillWindow.polyfillsLoaded =
    polyfillWindow.polyfillsLoaded || polyfillesLoadedFn;
function loadPolyfillv2(cb, features) {
    if (features === void 0) { features = ['es6', 'CustomEvent', 'fetch', 'HTMLPictureElement']; }
    return loadPolyfill(cb, "https://cdn.polyfill.io/v2/polyfill.min.js?features=" + features.join(',') + "&flags=gated&callback=polyfillsLoaded");
}
exports.loadPolyfillv2 = loadPolyfillv2;
function loadPolyfill(cb, 
// tslint:disable-next-line:max-line-length
src) {
    if (src === void 0) { 
    // tslint:disable-next-line:max-line-length
    src = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=es6,CustomEvent,fetch,HTMLPictureElement&flags=gated&callback=polyfillsLoaded'; }
    polyfillWindow.polyfillsLoadedCallbacks.push(cb);
    var script = get_script_by_src_1.default(src);
    if (script) {
        if (polyfillWindow.polyfillsLoadedFlag) {
            cb();
        }
    }
    else {
        document.head.appendChild(create_script_1.default(src));
    }
}
exports.default = loadPolyfill;
